import { createBrowserHistory, createHashHistory } from 'history';

// export default createBrowserHistory();

// HashHistory works fine on Cordova :)
export default createHashHistory();



// WEBPACK FOOTER //
// ./src/config/history.js